import { ActionButton } from "@via/components/action-button/action-button.tsx";
import Drawer from "@via/components/drawer.tsx";
import { SkeletonLoader } from "@via/components/loading/loading.tsx";
import CredentialKeyForm from "@via/pages/account/profile/credentials/credential-key-form/credential-key-form.tsx";
import EditSshCredentialForm from "@via/pages/account/profile/credentials/credential-key-form/ssh/edit-ssh-credential-form.tsx";
import CredentialKeysTable from "@via/pages/account/profile/credentials/table/credential-keys-table.tsx";
import { useGetSavedCredentials } from "@via/pages/account/profile/profile.api.tsx";
import { BUTTONS } from "@via/utils/constants.tsx";
import { CredentialView, Ssh } from "common";
import { type JSX, useState } from "react";

export default function Credentials(): JSX.Element {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [sshCredentialToEdit, setSshCredentialToEdit] = useState<Ssh | null>(
    null
  );

  const { data: savedCredentials, isLoading: isSavedCredentialsLoading } =
    useGetSavedCredentials({ type: CredentialView.UserOwned });

  return (
    <div>
      <div className="p-6 shadow-sm ring-1 ring-gray-900/5 sm:mx-0 sm:w-full sm:rounded-lg">
        <div className="via-page-heading-wrapper">
          <h2 className="via-h2">Credential Keys</h2>

          <ActionButton
            button={BUTTONS.CREATE_CREDENTIAL}
            onClick={() => {
              setDrawerOpen(true);
            }}
          />
        </div>

        {isSavedCredentialsLoading ? (
          <div className="my-4">
            <SkeletonLoader count={12} />
          </div>
        ) : (
          <div>
            <CredentialKeysTable
              credentials={savedCredentials || {}}
              onEditSshCredential={setSshCredentialToEdit}
            />
          </div>
        )}

        <Drawer id="credentials" open={isDrawerOpen} setOpen={setDrawerOpen}>
          <CredentialKeyForm setOpen={setDrawerOpen} />
        </Drawer>

        <Drawer
          id="edit-ssh"
          open={!!sshCredentialToEdit}
          setOpen={() => setSshCredentialToEdit(null)}>
          {sshCredentialToEdit ? (
            <EditSshCredentialForm
              credential={sshCredentialToEdit}
              setOpen={() => setSshCredentialToEdit(null)}
            />
          ) : (
            <></>
          )}
        </Drawer>
      </div>
    </div>
  );
}
